var applyThemeFontFamily = function (gearboxTheme) {
    return gearboxTheme.fontFamily ? "font-family: " + gearboxTheme.fontFamily : '';
};
var applyThemeFontSize = function (gearboxTheme) {
    return gearboxTheme.fontSize ? "font-size: " + gearboxTheme.fontSize : '';
};
var applyThemeListHighlight = function (gearboxTheme) {
    return gearboxTheme.listHighlight
        ? "background: " + gearboxTheme.listHighlight + " !important"
        : '';
};

export { applyThemeFontFamily as a, applyThemeFontSize as b, applyThemeListHighlight as c };
